export default "__VITE_ASSET__DSkxIH26__"